import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UiNavbarComponent } from './ui-navbar/ui-navbar.component';
import { UiThemeModule } from '@fitscovery/partner-web/ui/theme';
import { SharedPartnerWebUiMobileNavModule } from '@fitscovery/partner-web/ui/ui-mobile-nav';
import { RouterModule } from '@angular/router';
import { PartnerWebUiMembershipButtonModule } from '@fitscovery/partner-web/ui/membership-button';
import { ApiPartnerService } from '@fitscovery/partner/data-access';
import { TranslateModule } from '@ngx-translate/core';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { FlexLayoutModule } from '@angular/flex-layout';
import { SnackbarService } from '@fitscovery/ui/snackbar';

const COMPONENTS = [
  SharedPartnerWebUiMobileNavModule,
  PartnerWebUiMembershipButtonModule
];

@NgModule({
  imports: [
    CommonModule, 
    UiThemeModule,
    RouterModule,
    TranslateModule,
    FlexLayoutModule,
    NgxSkeletonLoaderModule,
    COMPONENTS
  ],
  declarations: [UiNavbarComponent],
  exports: [UiNavbarComponent],
  providers: [ApiPartnerService, SnackbarService]
})
export class SharedPartnerWebUiNavbarModule {}
